<!--
 * @message: 常规文字、数字输入框
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-09-08 18:27:19
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_normalInputTextFiled.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-06-07 14:04:17
-->
<template>
  <div class="d-flex justify-start flex-column">
    <v-sheet class="text--secondary d-inline-block text-truncate">
      <span :class="labelClass" v-if="showLabel">{{ label }}</span>
    </v-sheet>
    <!-- :label="filled ? label : ''" -->
    <v-text-field
      v-if="!textArea"
      v-model="curValue"
      :filled="filled"
      :hide-details="hideDetails"
      :single-line="singleLine"
      :hint="hint"
      :height="height"
      :type="filled ? type : 'text'"
      @focus="
        focus = true;
        canFocus = true;
        $emit('focus');
      "
      :placeholder="placeholder"
      :maxlength="maxlength"
      @blur="focus = false"
      :rules="canFocus ? rules : []"
      :dense="dense"
      :error="isError"
      :suffix="suffix"
      :autofocus="autofocus"
      :prefix="prefix"
      :messages="curMessage"
      :error-messages="errorMsg"
      :disabled="disabled"
      :readonly="readonly"
    >
      <template v-slot:prepend-inner>
        <slot name="prepend-inner" />
      </template>
      <template v-slot:append>
        <slot name="append" />
      </template>
    </v-text-field>
    <v-textarea
      v-if="textArea"
      v-model="curValue"
      :filled="filled"
      :single-line="singleLine"
      :hint="hint"
      auto-grow
      no-resize
      rows="1"
      :height="height"
      :type="filled ? type : 'text'"
      @focus="
        focus = true;
        canFocus = true;
        $emit('focus');
      "
      :placeholder="placeholder"
      :maxlength="maxlength"
      @blur="focus = false"
      :rules="canFocus ? rules : []"
      :dense="dense"
      :error="isError"
      :hide-details="hideDetails"
      :suffix="suffix"
      :autofocus="autofocus"
      :prefix="prefix"
      :messages="curMessage"
      :error-messages="errorMsg"
      :disabled="disabled"
      :readonly="readonly"
    >
      <template v-slot:prepend-inner>
        <slot name="prepend-inner" />
      </template>
      <template v-slot:append>
        <slot name="append" />
      </template>
    </v-textarea>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "mrc_normal_input",
  model: {
    prop: "value",
    event: "input",
  },
  computed: {
    ...mapGetters(["pageTriger"]),
    curValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        return val;
      },
    },
    curMessage() {
      if (this.errorMsg) {
        return "";
      } else {
        return this.message;
      }
    },
    isRequire() {
      return this.rules.length ? true : false;
    },
    labelClass() {
      let cla = "";
      if (this.isRequire && !this.isNotRequire) {
        cla += " mrc_text_require";
      }
      if (this.focus) {
        cla += " primary--text";
      }
      if (this.isError) {
        cla += " red--text";
      }
      return cla;
    },
    isError() {
      // if (this.pageTriger && this.rules) {
      //   return this.isObjectNull(this.valueArr);
      // }

      if (!this.canFocus) {
        return false;
      }
      if (this.rules == null || this.rules.length == 0) {
        return false;
      }
      if (
        this.rules != null &&
        this.rules.length == 1 &&
        this.rulesSync.indexOf("length") != -1
      ) {
        return false;
      }
      return this.isObjectNull(this.curValue);
    },
    errorMsg() {
      if (this.rules == null || this.rules.length == 0) {
        return null;
      }
      if (!this.canFocus) return null;

      if (this.isObjectNull(this.curValue)) {
        return (
          this.$t("verify_essweb_form_textField_dataCommonLabel") +
          this.$t("verify_essweb_form_textField_textisNullTextLabel")
        );
      } else {
        return null;
      }
    },
  },
  props: {
    //规则
    rules: {
      default: function () {
        return [];
      },
      type: Array,
    },
    rulesSync: {
      default: function () {
        return [];
      },
      type: Array,
    },
    textArea: { default: false, type: [Boolean, Number] },
    isNotRequire: { default: false, type: [Boolean, Number] },
    autofocus: { default: false, type: [Boolean, Number] },
    value: { default: "", type: [String, Number, Array, Object] },
    prefix: { default: "", type: [Number, String, Array, Object] },
    suffix: { default: "", type: [Number, String, Array, Object] },
    label: { default: "", type: String },
    message: { default: "", type: String },
    placeholder: { default: "", type: [String, Function] },
    height: { default: "", type: [String, Number] },
    singleLine: { default: true, type: Boolean },
    hideDetails: { default: false, type: [Boolean, Number] },
    showLabel: { default: true, type: Boolean },
    hint: { default: "", type: String },
    type: { default: "text", type: [String] },
    filled: { default: true, type: Boolean },
    maxlength: { default: 150, type: [String, Number, Array, Object] },
    readonly: { default: false, type: Boolean },
    password: { default: null, type: [Object, Array] }, //修改密码时候，密码输入专用
    disabled: { default: false, type: Boolean },
    dense: { default: true, type: Boolean },
    // type=numbber
    min: { default: null, type: [Object, Number, String] },
    max: { default: null, type: [Object, Number, String] },
  },

  watch: {
    pageTriger(val) {
      if (val) this.canFocus = true;
    },
    value(val) {
      // if (Number(this.min) !== null && Number(this.min) !== undefined) {
      //   if (Number(val) < Number(this.min)) this.curValue = Number(this.min);
      // } else if (Number(this.max) !== null || Number(this.max) !== undefined) {
      //   if (Number(val) > Number(this.max)) this.curValue = Number(this.max);
      // } else {
      this.curValue = val;
      // }
    },
    curValue(val) {
      // if (this.maxlength != undefined && this.type == "number") {
      //   if (val.toString().length > Number(this.maxlength))
      //     val = val.toString().slice(0, 10);
      //   this.curValue = val;
      //   this.$emit("input", val);
      // } else if (val.toString().indexOf("-") != -1) {
      //   val = val.toString().replace(/\-/g, "");
      //   this.curValue = val;
      // } else {
      this.$emit("input", val);
      // }
    },
  },
  data() {
    return { focus: false, canFocus: false };
  },
  mounted() {
    this.canFocus = false;
  },
  methods: {
    isObjectNull: function (obj) {
      const that = this;
      if (this.isNotRequire) {
        return false;
      }
      if (obj === 0) {
        return false;
      }
      if (obj == "") {
        return true;
      }
      return false;
    },
  },
};
</script>
